<template>
  <div class="tyndall-scattering-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>光路可见性 | 区别溶液与胶体$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Glass Tank 1 (Solution - No Path) -->
          <rect x="50" y="80" width="120" height="80" fill="rgba(255,255,255,0.05)" stroke="#888" />
          <text x="60" y="70" fill="#888" font-size="8">真溶液 (无光路)</text>

          <!-- Glass Tank 2 (Colloid - Visible Path) -->
          <rect x="230" y="80" width="120" height="80" fill="rgba(0, 210, 255, 0.05)" stroke="#00d2ff" />
          <text x="240" y="70" fill="#00d2ff" font-size="8">胶体 (光路清晰)</text>

          <!-- Laser Beam -->
          <line x1="10" y1="120" x2="400" y2="120" stroke="#ff4757" stroke-width="3" opacity="0.3" />
          
          <!-- Tyndall path in tank 2 -->
          <line v-if="active" x1="230" y1="120" x2="350" y2="120" stroke="#ff4757" stroke-width="4">
             <animate attributeName="opacity" values="0.6;1;0.6" dur="0.5s" repeatCount="indefinite" />
          </line>

          <!-- Scattering dots in tank 2 -->
          <circle v-for="n in 50" :key="n" :cx="230 + Math.random()*120" :cy="80 + Math.random()*80" r="1" fill="#fff" :opacity="active ? 0.3 : 0.05" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>鉴别方法: 激光笔照射产生光锥</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="danger" size="mini" @click="active = !active">{{ active ? '关闭激光' : '开启激光 (检测)' }}</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当一束光线透过胶体（如云雾、肥皂水）时，从垂直光束的方向可以观察到一条明亮的光路，这就是**丁达尔效应**。这是因为胶体粒子的直径（1-100nm）与可见光波长相近，会使光发生**散射**。而在分子的真溶液（如糖水）中，溶质粒子太小，不足以发生肉眼可见的散射。该效应常用于化学中鉴别胶体系统。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TyndallScatteringViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      active: true
    }
  }
}
</script>

<style scoped lang="scss">
.tyndall-scattering-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
